import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  loadingBoxActivationDate: {
    height: 20,
    width: 130,
  },
  loadingBoxBusinessCoach: {
    height: 20,
    width: 100,
  },
  loadingBoxEQSB: {
    height: 20,
    width: 80,
  },
  loadingBoxGroupQualifyingVolume: {
    height: 20,
    width: 140,
  },
  loadingBoxOrderingEntities: {
    height: 20,
    width: 90,
  },
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemContainer: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
